export const DataGridPaginationProp = Object.freeze({
    ActivePage: 'activePage',
    TotalPages: 'totalPages',
    RecordsPerPage: 'recordsPerPage',
    RecordsPerPageOptions: 'recordsPerPageOptions',
    TotalRecordsCount: 'totalRecordsCount',
});